
import { get, post } from './http'

const base = '/operating-platform/campaign/frontend/invitation'
const activity = {
  // inviter
  getInviterData: (params) => {
    return get(`${base}/page/inviter`, params)
  },
  // 被邀请页
  getInviteeData: (params) => {
    return get(`${base}/page/invitee`, params)
  },
  // 新老用户
  getNewUser: (params) => {
    return post(`${base}/inviteLogin`, params)
  },
  // 邀请历史
  getInviteList: (params) => {
    return get(`${base}/history/query`, params)
  },
  // 本期中奖
  getCurrentWinner: (params) => {
    return get(`${base}/winner`, params)
  },
  // 往期中奖
  getPreviousWinner: (params) => {
    return get(`${base}/history/winner`, params)
  },
  // 邀请码
  getInviterCode: (params) => {
    return get(`${base}/code`, params)
  },
}
export default activity


